// extracted by mini-css-extract-plugin
export var banner = "_2g-0";
export var icon = "_2g-1";
export var message = "_2g-2";